import { FunctionComponent } from "react";
import BackgroundMesh from "./background-mesh";
import { StyledPanel, StyledContainer } from "./page-content.styles";

interface PageContentProps {
  children: React.ReactNode;
}

const PageContent: FunctionComponent<PageContentProps> = ({ children }) => {
  return (
    <BackgroundMesh>
      <StyledContainer>
        <StyledPanel>{children}</StyledPanel>
      </StyledContainer>
    </BackgroundMesh>
  );
};

export default PageContent;
